import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import logo from '../../images/logo/saaswatch logo.png'

const Header = (props) => {

    const [mobileActive, setMobileActive] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const navLinkStyle = {
        color: isSticky ? '#374151' : 'rgba(255, 255, 255, 0.9)',
        fontWeight: '500',
        fontSize: '15px',
        padding: '10px 20px',
        cursor: 'pointer',
        transition: 'color 0.3s ease',
        textDecoration: 'none'
    };

    const navLinkHoverStyle = {
        color: isSticky ? '#3b82f6' : '#ffffff'
    };

    return (
        <header
            className={`header-modern ${isSticky ? 'header-sticky' : ''}`}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                padding: isSticky ? '12px 0' : '20px 0',
                background: isSticky ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
                backdropFilter: isSticky ? 'blur(10px)' : 'none',
                boxShadow: isSticky ? '0 4px 30px rgba(0, 0, 0, 0.1)' : 'none',
                transition: 'all 0.3s ease'
            }}
        >
            <div className="container">
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    {/* Logo */}
                    <div className="header-logo">
                        <NavLink onClick={ClickHandler} to="/">
                            <img
                                src={logo}
                                alt="SaaS Watch"
                                width="140"
                            />
                        </NavLink>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="d-none d-xl-block">
                        <ul style={{
                            display: 'flex',
                            alignItems: 'center',
                            listStyle: 'none',
                            margin: 0,
                            padding: 0,
                            gap: '8px'
                        }}>
                            {props.source === 'home' && <>
                                <li>
                                    <Link
                                        to="features"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        style={navLinkStyle}
                                        onMouseOver={(e) => e.target.style.color = navLinkHoverStyle.color}
                                        onMouseOut={(e) => e.target.style.color = navLinkStyle.color}
                                    >
                                        Features
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="funfact"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        style={navLinkStyle}
                                        onMouseOver={(e) => e.target.style.color = navLinkHoverStyle.color}
                                        onMouseOut={(e) => e.target.style.color = navLinkStyle.color}
                                    >
                                        How it works
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="pricing"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        style={navLinkStyle}
                                        onMouseOver={(e) => e.target.style.color = navLinkHoverStyle.color}
                                        onMouseOut={(e) => e.target.style.color = navLinkStyle.color}
                                    >
                                        Pricing
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="contact"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        style={navLinkStyle}
                                        onMouseOver={(e) => e.target.style.color = navLinkHoverStyle.color}
                                        onMouseOut={(e) => e.target.style.color = navLinkStyle.color}
                                    >
                                        Contact
                                    </Link>
                                </li>
                            </>}
                            {props.source !== 'home' && <>
                                <li><NavLink to="/#features" style={navLinkStyle}>Features</NavLink></li>
                                <li><NavLink to="/#funfact" style={navLinkStyle}>How it works</NavLink></li>
                                <li><NavLink to="/#pricing" style={navLinkStyle}>Pricing</NavLink></li>
                            </>}
                        </ul>
                    </nav>

                    {/* CTA Button */}
                    <div className="d-none d-md-block">
                        <Link
                            to="contact"
                            spy={true}
                            smooth={true}
                            duration={500}
                            offset={-100}
                            className="btn-gradient"
                            style={{
                                padding: '12px 24px',
                                fontSize: '14px',
                                cursor: 'pointer'
                            }}
                        >
                            Sign up
                            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="d-xl-none">
                        <button
                            onClick={() => setMobileActive(!mobileActive)}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                padding: '10px',
                                cursor: 'pointer'
                            }}
                            aria-label="Toggle mobile menu"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M3 12H21M3 6H21M3 18H21"
                                    stroke={isSticky ? '#374151' : 'white'}
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            {/* Modern Mobile Menu */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '100%',
                    maxWidth: '320px',
                    height: '100vh',
                    background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
                    boxShadow: mobileActive ? '-10px 0 40px rgba(0,0,0,0.15)' : 'none',
                    transform: mobileActive ? 'translateX(0)' : 'translateX(100%)',
                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    zIndex: 1001,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                }}
            >
                {/* Mobile Menu Header */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px 24px',
                    borderBottom: '1px solid rgba(0,0,0,0.06)'
                }}>
                    <NavLink onClick={() => { ClickHandler(); setMobileActive(false); }} to="/">
                        <img src={logo} alt="SaaS Watch" width="120" />
                    </NavLink>
                    <button
                        onClick={() => setMobileActive(false)}
                        style={{
                            background: '#f3f4f6',
                            border: 'none',
                            width: '40px',
                            height: '40px',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease'
                        }}
                        aria-label="Close menu"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>

                {/* Mobile Menu Navigation */}
                <nav style={{ flex: 1, padding: '24px', overflowY: 'auto' }}>
                    <ul style={{
                        listStyle: 'none',
                        margin: 0,
                        padding: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px'
                    }}>
                        {props.source === 'home' ? (
                            <>
                                <li>
                                    <Link
                                        to="features"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        onClick={() => setMobileActive(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            color: '#1f2937',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            textDecoration: 'none',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            background: 'transparent'
                                        }}
                                        onMouseOver={(e) => e.target.style.background = '#f3f4f6'}
                                        onMouseOut={(e) => e.target.style.background = 'transparent'}
                                    >
                                        <span style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '10px',
                                            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(29, 78, 216, 0.1) 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '12px'
                                        }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M2 17L12 22L22 17" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M2 12L12 17L22 12" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </span>
                                        Features
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="funfact"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        onClick={() => setMobileActive(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            color: '#1f2937',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            textDecoration: 'none',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            background: 'transparent'
                                        }}
                                        onMouseOver={(e) => e.target.style.background = '#f3f4f6'}
                                        onMouseOut={(e) => e.target.style.background = 'transparent'}
                                    >
                                        <span style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '10px',
                                            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(29, 78, 216, 0.1) 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '12px'
                                        }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <circle cx="12" cy="12" r="10" stroke="#3b82f6" strokeWidth="2"/>
                                                <path d="M12 6V12L16 14" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round"/>
                                            </svg>
                                        </span>
                                        How it works
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="pricing"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        onClick={() => setMobileActive(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            color: '#1f2937',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            textDecoration: 'none',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            background: 'transparent'
                                        }}
                                        onMouseOver={(e) => e.target.style.background = '#f3f4f6'}
                                        onMouseOut={(e) => e.target.style.background = 'transparent'}
                                    >
                                        <span style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '10px',
                                            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(29, 78, 216, 0.1) 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '12px'
                                        }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </span>
                                        Pricing
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="contact"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        onClick={() => setMobileActive(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            color: '#1f2937',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            textDecoration: 'none',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            background: 'transparent'
                                        }}
                                        onMouseOver={(e) => e.target.style.background = '#f3f4f6'}
                                        onMouseOut={(e) => e.target.style.background = 'transparent'}
                                    >
                                        <span style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '10px',
                                            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(29, 78, 216, 0.1) 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '12px'
                                        }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M22 16.92V19.92C22 20.4704 21.7893 20.9996 21.4142 21.3946C21.0391 21.7896 20.5304 22.0204 20 22.04C16.8621 21.7227 13.8575 20.6441 11.24 18.91C8.79702 17.3272 6.73099 15.2611 5.14802 12.82C3.40005 10.1884 2.32098 7.16583 2.02002 4.01C2.00002 3.48 2.23002 2.97 2.62502 2.6C3.02002 2.22 3.55002 2.01 4.10002 2.01H7.10002C8.07002 2 8.90002 2.73 9.03002 3.69C9.15002 4.69 9.39002 5.67 9.73002 6.61C10.01 7.38 9.84002 8.25 9.29002 8.85L8.09002 10.14C9.55102 12.7354 11.6844 14.9234 14.24 16.46L15.46 15.18C16.06 14.58 16.93 14.4 17.7 14.69C18.64 15.03 19.62 15.27 20.62 15.39C21.6 15.52 22.34 16.38 22.31 17.37L22 16.92Z" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </span>
                                        Contact
                                    </Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li>
                                    <NavLink
                                        to="/#features"
                                        onClick={() => setMobileActive(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            color: '#1f2937',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            textDecoration: 'none',
                                            borderRadius: '12px',
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        Features
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to="/#funfact"
                                        onClick={() => setMobileActive(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            color: '#1f2937',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            textDecoration: 'none',
                                            borderRadius: '12px',
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        How it works
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to="/#pricing"
                                        onClick={() => setMobileActive(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            color: '#1f2937',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            textDecoration: 'none',
                                            borderRadius: '12px',
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        Pricing
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to="/#contact"
                                        onClick={() => setMobileActive(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            color: '#1f2937',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            textDecoration: 'none',
                                            borderRadius: '12px',
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        Contact
                                    </NavLink>
                                </li>
                            </>
                        )}
                    </ul>
                </nav>

                {/* Mobile Menu Footer with CTA */}
                <div style={{
                    padding: '24px',
                    borderTop: '1px solid rgba(0,0,0,0.06)',
                    background: '#f8fafc'
                }}>
                    {props.source === 'home' ? (
                        <Link
                            to="contact"
                            spy={true}
                            smooth={true}
                            duration={500}
                            offset={-100}
                            onClick={() => setMobileActive(false)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                padding: '16px 24px',
                                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                color: 'white',
                                fontSize: '16px',
                                fontWeight: '600',
                                textDecoration: 'none',
                                borderRadius: '12px',
                                cursor: 'pointer',
                                boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)'
                            }}
                        >
                            Sign up
                            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    ) : (
                        <NavLink
                            to="/#contact"
                            onClick={() => setMobileActive(false)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                padding: '16px 24px',
                                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                color: 'white',
                                fontSize: '16px',
                                fontWeight: '600',
                                textDecoration: 'none',
                                borderRadius: '12px',
                                boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)'
                            }}
                        >
                            Sign up
                            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </NavLink>
                    )}
                </div>
            </div>

            {/* Mobile Menu Backdrop */}
            <div
                onClick={() => setMobileActive(false)}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.5)',
                    backdropFilter: 'blur(4px)',
                    opacity: mobileActive ? 1 : 0,
                    visibility: mobileActive ? 'visible' : 'hidden',
                    transition: 'all 0.3s ease',
                    zIndex: 1000
                }}
            />
        </header>
    )
}

export default Header;
